import useAuthStore from '@/stores/authStore';
import type { NavigationGuardWithThis } from 'vue-router';

export default <NavigationGuardWithThis<undefined>>((to, _from, next) => {
  const authStore = useAuthStore();
  if (!authStore.isAuth && to.name !== 'auth.login') {
    return next({
      name: 'auth.login',
    });
  }

  return next();
});
